// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1DQHg","image":"App_image__3hm47"};